import React, { useEffect } from "react"; 
import { Button, Form, Input, Space, InputNumber } from "antd"; 
import "./edit_table_wh_transfer_request.css";

interface DataType {
    key: React.Key;
    item_code: string;
    item_name: string;
    uom: string;
    qty: number;
}

interface EditTableWhTransferRequestProps {
    item: DataType;
    onSave: (key: React.Key, newQty: number) => void;
    onCancel: () => void;
}

const EditTableWhTransferRequest: React.FC<EditTableWhTransferRequestProps> = ({ item, onSave, onCancel }) => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    const [form] = Form.useForm();

    useEffect(() => {
        if (item) {
            form.setFieldsValue({
                item_code: item.item_code,
                item_name: item.item_name,
                uom: item.uom,
                qty: item.qty,
            });
        }
    }, [item, form]);

    const handleEditClick = () => {
        form.validateFields().then(values => {
            onSave(item.key, values.qty);
        }).catch(info => {
            console.log('Validate Failed:', info);
        });
    };

    return (

        <div id="ieml" style={transformStyle}>
            <div className="gjs-grid-row" id="ieug">
                <div className="gjs-grid-column" id="i3ds">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                        onFinish={handleEditClick}
                    >
                        <Form.Item
                            label="Item Code"
                            name="item_code"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Item Name"
                            name="item_name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="UoM"
                            name="uom"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Qty"
                            name="qty"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Please input quantity!' }]}
                        >
                            <InputNumber min={1} style={{ width: '100%' }} placeholder="" />
                        </Form.Item>
                        <Space style={{ paddingTop: "20px" }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    height: "40px",
                                    width: "120px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ width: "22px", height: "22px" }}>
                                        <path
                                            fillRule="evenodd"
                                            d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                }>
                                Edit
                            </Button>
                            <Button
                                type="primary"
                                onClick={onCancel}
                                style={{
                                    height: "40px",
                                    width: "120px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "red",
                                    color: "white",
                                    border: "none",
                                }}>
                                Cancel
                            </Button>
                        </Space>
                    </Form>

                </div>
            </div>
        </div>
    );
};

export default EditTableWhTransferRequest;